window.addEventListener("hs-form-event:on-ready", (event) => {
    const renderEl = event.target;
    const form = renderEl?.querySelector("form");
    const formID = form?.dataset.formId || null;
    const containerEl = document.querySelector(
        `.hs-form-html[data-form-id="${formID}"]`,
    );
    const hubspotform = HubSpotFormsV4.getFormFromEvent(event);

    if (!hubspotform) {
        console.log("HubSpot form not found from event");
        return;
    }

    const topic = containerEl?.dataset.topic || document.title;
    const leadSource = containerEl?.dataset.leadSource;
    const leadSourceName = containerEl?.dataset.leadSourceName;
    const segment = containerEl?.dataset.segment;

    if (topic) {
        hubspotform.setFieldValue("0-1/topic", topic);
    }

    if (leadSource) {
        hubspotform.setFieldValue("0-1/lead_source_picklist", leadSource);
    }

    if (leadSourceName) {
        hubspotform.setFieldValue("0-1/lead_source_name", leadSourceName);
    }

    if (segment) {
        hubspotform.setFieldValue("0-1/segment", segment);
    }
});
